var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"alert",class:[_vm.colorClass]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('span',{staticClass:"close",on:{"click":_vm.close}},[_c('i',{staticClass:"bi bi-x-lg"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }